// extracted by mini-css-extract-plugin
export default {"container":"ZoneOverviewInterchain_container__3t+0r","cardContent":"ZoneOverviewInterchain_cardContent__i1EmU","valueBlock":"ZoneOverviewInterchain_valueBlock__mp4Kx"};